import { render, staticRenderFns } from "./SettingsNotificationSmtpNameFrom.vue?vue&type=template&id=38032aa4&"
import script from "./SettingsNotificationSmtpNameFrom.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationSmtpNameFrom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports